import { PropertyRef, defineBool, defineEnum } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

// HackWeek 27 - 31 March 2023
// Second Experiment (4th May)
// The control will show the survey option (ReasonSelector component)
// The target will omit that step.
export enum FeedbackStatus {
  SHOW_SURVEY = 'SHOW_SURVEY',
  DO_NOT_SHOW_SURVEY = 'DO_NOT_SHOW_SURVEY',
  ORIGINAL = 'ORIGINAL',
}

export const showSurveyOptionEnum = defineEnum({
  name: 'showSurveyOption',
  description: 'A/B-test to improve the UX in the FeedbackWidget',
  values: FeedbackStatus,
  default: FeedbackStatus.ORIGINAL,
});

export const s4aLaunchedBool = defineBool({
  name: 's4aLaunched',
  description: 'Boolean to control the S4A Turnkey site visibility',
  default: false,
});

export const s4pLaunchedBool = defineBool({
  name: 's4pLaunched',
  description: 'Boolean to control the S4P Turnkey site visibility',
  default: false,
});

export const samCtaForArticlePageBool = defineBool({
  name: 'samCtaForArticlePage',
  description: 'Boolean to control the SAM CTA visibility on article page',
  default: false,
});

/**
 * Hindi messaging rollout (FA-2973)
 */
export const hindiMessagingBool = defineBool({
  name: 'hindiMessaging',
  description: 'Hindi messaging rollout',
  default: false,
});

export const simplifiedMasthead = defineBool({
  name: 'simplifiedMasthead',
  description: 'Boolean to control a simplified masthead for support site',
  default: false,
});

export const properties: Array<PropertyRef> = [
  ubiTestBool,
  showSurveyOptionEnum,
  s4aLaunchedBool,
  hindiMessagingBool,
  s4pLaunchedBool,
  samCtaForArticlePageBool,
  simplifiedMasthead,
];

export type PropertyTypes = (typeof properties)[number]['_type'];
